export type ScoopUrgency = '火' | '急' | '寻';

export interface ScoopRequest {
  id: string;
  num: string;
  category: string;
  urgency: ScoopUrgency;
  title: string;
  target: string;
  desc: string;
  leads: number;
  deadline: string;
  source: string;
}

export const SCOOP_CATEGORIES = ['全部征集', '文娱瓜田', '职场真相', '消费维权', '平台纠纷', '学术与公益', '公共事件'];

export const FEATURED_SCOOP: ScoopRequest = {
  id: 'feature-01',
  num: 'XL-26-0712',
  category: '消费维权',
  urgency: '火',
  title: '“到手价缩水”征集令：结算价与页面宣称到手价不符的对账单与录屏',
  target: '曾参与同一场大促、并发现实付金额与页面宣称存在差价的下单用户',
  desc: '我们在横向比对多个订单时发现，部分商品的“到手价”页面标注与实际结算存在出入。现公开征集同一活动场次的下单录屏、实付截图与到账记录，用于交叉比对是否存在系统性价差。线索越多，越能看清真相。',
  leads: 14,
  deadline: '长期有效',
  source: '平台编辑部发起',
};

export const SCOOP_REQUESTS: ScoopRequest[] = [
  {
    id: 's-01',
    num: 'XL-26-0711',
    category: '文娱瓜田',
    urgency: '急',
    title: '某团体出道夜疑似“换票”？征集现场应援手幅与落座时间戳',
    target: '现场观众、应援负责人及看到入场座位调整的在场者',
    desc: '希望征集当晚的应援区照片、手幅时间戳与落座记录，比对官方公布的座位与现场实际情况是否一致。',
    leads: 9,
    deadline: '征集至本月 18 日',
    source: '热心网友求料',
  },
  {
    id: 's-02',
    num: 'XL-26-0709',
    category: '职场真相',
    urgency: '寻',
    title: '大厂“末位淘汰”口语化辞退：征集考勤记录与谈话录音节选',
    target: '近年经历口头劝退、被要求“主动离职”的职场人',
    desc: '长期关注隐性的末位淘汰操作。现征集相关考勤、绩效邮件与谈话沟通记录，用于整理各厂做法的共性与差异。',
    leads: 21,
    deadline: '长期有效',
    source: '职场频道持续跟进',
  },
  {
    id: 's-03',
    num: 'XL-26-0708',
    category: '平台纠纷',
    urgency: '火',
    title: '外卖商家被“差评封店”操作案例征集：处罚通知与申诉记录',
    target: '遭遇差评后店铺被限流或直接封禁、申诉无果的商家',
    desc: '不少商家反映“一条差评就封店”。现征集处罚通知截图、申诉流转记录与订单纠纷背景，看看封店标准究竟如何。',
    leads: 32,
    deadline: '长期有效',
    source: '商家互助线索',
  },
  {
    id: 's-04',
    num: 'XL-26-0705',
    category: '学术与公益',
    urgency: '寻',
    title: '论文“代写代发”中介报价与流程截图征集',
    target: '曾接触过代写中介、或被套路过费用的硕博学生',
    desc: '公开征集中介报价单、承诺书与“包录用”话术截图，还原整条灰色产业链的定价与运作路径。',
    leads: 6,
    deadline: '征集至月底',
    source: '平台编辑部发起',
  },
  {
    id: 's-05',
    num: 'XL-26-0703',
    category: '公共事件',
    urgency: '急',
    title: '小区物业费拟涨价的业主群通知与表决记录征集',
    target: '近期物业拟调价、正在走书面表决程序的小区业主',
    desc: '关注物业费调价中的程序问题。征集业主群通知、上门表决票样与公示文件，帮助判断流程是否规范。',
    leads: 11,
    deadline: '长期有效',
    source: '热心网友求料',
  },
  {
    id: 's-06',
    num: 'XL-26-0630',
    category: '文娱瓜田',
    urgency: '寻',
    title: '剧组疑似“压番”宣传物料：征集角色顺序不同的二版海报',
    target: '关注该剧组官宣动态、见过前后版本宣传图的粉丝',
    desc: '同一作品宣传期角色排序出现反复，疑似番位协商波动。征集不同时间段的海报与文案截图作时间线比对。',
    leads: 4,
    deadline: '长期有效',
    source: '热心网友求料',
  },
  {
    id: 's-07',
    num: 'XL-26-0627',
    category: '职场真相',
    urgency: '寻',
    title: '各行业“无偿试岗”岗位信息与面试截图征集',
    target: '被要求“先无偿试岗数日”或“培训无补贴”的求职者',
    desc: '想摸清“试岗即白嫖”的普遍程度。征集招聘信息、沟通记录与实际试岗反馈，按行业整理一份避坑名单。',
    leads: 17,
    deadline: '长期有效',
    source: '职场频道持续跟进',
  },
  {
    id: 's-08',
    num: 'XL-26-0621',
    category: '消费维权',
    urgency: '急',
    title: '“以旧换新”补贴未到账：征集核销成功但钱没到位的用户',
    target: '参加平台以旧换新、核销成功却迟迟未收到补贴款的用户',
    desc: '多起“补贴显示成功、钱迟迟不到账”的案例。征集下单时间、核销状态与客服沟通记录，统一汇总处理。',
    leads: 26,
    deadline: '征集至 20 日',
    source: '平台编辑部发起',
  },
];